export enum ValidatorPatterns {
    Email = '/[A-z0-9!#$%&\'*+/=?^_\\`{|}~-]+(?:\\\\.[a-z0-9!#$%&\'*+/=?^_\\`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?',
    EmailSupport = '/[^\\s]{3,}$/',
}

export const PATTERN_EMAIL = `[A-z0-9!#$%&'*+/=?^_\`{|}~-]+(?:\\.[A-z0-9!#$%&'*+/=?^_\`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?`;
export const PATTERN_EMAIL_PATH_SUPPORT = '[^\\s]{3,}$';
export const PATTERN_PHONE = '^[0-9]{1,12}$';
export const PATTERN_NUMERIC = '^-?[0-9]\\d*(\\.\\d*)?$';
export const PATTERN_POSITIVE_NUMERIC = '^[0-9]\\d*(\\.\\d*)?$';
export const PATTERN_INTEGER = '^-?[0-9]\\d*$';
export const PATTERN_PERCENTAGE =
    '^100(\\.0{0,2})? *%?$|^\\d{1,2}(\\.\\d{1,2})? *%?$';
export const PATTERN_PERCENTAGE_INTEGER =
    '^100(\\.0{0,2})? *%?$|^\\d{1,2}? *%?$';
export const PATTERN_POSITIVE_INTEGER_WITHOUT_ZERO = '^[1-9]+[0-9]*$';
